module.exports = __webpack_public_path__ + "img/background2_22.19d5efe2.webp";